module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"studies":"Studies","comments":"Comments","settings":"Settings"},"fr":{"studies":"Etudes","comments":"Commentaires","settings":"Réglages"}}')
  delete Component.options._Ctor
}
